import GeneralSlider from './Slider';
import MenuSlider from './Slider.menu';

export default function Component(props) {
    const { tipus } = props;
    return tipus === 'menu' ? <MenuSlider {...props} /> : <GeneralSlider {...props} />;
}
